import { getOrCreateBubble } from './common';

const _appendSender = (messages, messageGroup, type, senderName) => {
  const lastMessageGroup = messages.querySelector('.aws-chatkit-message-group:last-child');
  const isSameSender = lastMessageGroup && lastMessageGroup.classList.contains(type);

  if (isSameSender) return;

  const sender = document.createElement('div');
  sender.className = 'aws-chatkit-message-sender';
  sender.textContent = senderName;
  messageGroup.appendChild(sender);
};

const _appendText = (messageGroup, text) => {
  const bubble = getOrCreateBubble(messageGroup);

  const textEl = document.createElement('div');
  textEl.className = 'aws-chatkit-bubble-text';
  textEl.textContent = text;
  bubble.appendChild(textEl);
};

const _markMessagePending = (messageGroup, pendingMessageId) => {
  messageGroup.dataset.pendingMessageId = pendingMessageId;
  messageGroup.classList.add('pending');
};

export const unmarkMessagePending = (messageGroup) => {
  messageGroup.classList.remove('pending');
  messageGroup.dataset.pendingMessageId = null;
};

export const appendMessage = (container, type, text, senderName, pendingMessageId = null) => {
  const messages = container.querySelector('.aws-chatkit-messages');
  if (!messages) return null;

  const messageGroup = document.createElement('div');
  messageGroup.className = `aws-chatkit-message-group ${type}`;

  if (pendingMessageId) _markMessagePending(messageGroup, pendingMessageId);

  if (senderName) _appendSender(messages, messageGroup, type, senderName);
  if (text) _appendText(messageGroup, text);

  messages.appendChild(messageGroup);
  messages.scrollTop = messages.scrollHeight;
  return messageGroup;
};

export const clearComposer = (container) => {
  const input = container.querySelector('.aws-chatkit-composer-input');
  input.value = '';
  input.style.height = '';
};
